import { render, staticRenderFns } from "./zesa-tokens.vue?vue&type=template&id=6bdb5f09"
import script from "./zesa-tokens.vue?vue&type=script&lang=js"
export * from "./zesa-tokens.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports